module.exports = __webpack_public_path__ + "static/Heebo-Bold-bc68b4fe1c0fc61a234a10444467fb2b.ttf";